import { logger } from "@justhome/common";
import { ClientMode, usePostPartnerLead } from "@justhome/common/api/core";
import useLinks from "@lib/hooks/useLinks";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import TransferWithoutProperty from "@modules/application/components/TransferWithoutProperty";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { useRouter } from "next/router";
import { FC } from "react";

interface PartnerWithoutPropertyProps {
  clientMode: ClientMode;
}

const PartnerWithoutProperty: FC<PartnerWithoutPropertyProps> = ({
  clientMode,
}) => {
  const router = useRouter();
  const contactId = router.query["contact-id"] as string;
  const { dispatch } = useApplicationContext();
  const { partner } = usePartnerContext();

  const { getApplicationProcessLink } = useLinks();

  const {
    mutate: createLead,
    isError: isCreateLeadError,
    isLoading: isCreateLeadLoading,
  } = usePostPartnerLead({
    onSuccess(lead) {
      dispatch({
        type: "SET_LEAD",
        lead,
      });

      router.push(getApplicationProcessLink());
    },
    onError(error) {
      logger.error("Failed to create lead", error);
    },
  });

  const {
    mutateAsync: createLeadForBooking,
    isError: isCreateLeadForBookingError,
    isLoading: isCreateLeadForBookingLoading,
  } = usePostPartnerLead({
    onError(error) {
      logger.error("Failed to create lead", error);
    },
    onSuccess(lead) {
      dispatch({
        type: "SET_LEAD",
        lead,
      });

      router.push(getApplicationProcessLink("booking"));
    },
  });

  const handleGoToApplication = () => {
    if (contactId && partner) {
      createLead({
        body: {
          contactId,
          source: "EMAIL_TEMPLATE",
        },
        pathParams: {
          partnerId: partner?.id,
        },
        queryParams: {
          clientMode,
        },
      });
    } else {
      router.push(getApplicationProcessLink());
    }
  };

  const handleGoToBooking = () => {
    if (contactId && partner) {
      createLeadForBooking({
        body: {
          contactId: contactId,
          source: "EMAIL_TEMPLATE",
        },
        pathParams: {
          partnerId: partner?.id,
        },
        queryParams: {
          clientMode,
        },
      });
    } else {
      router.push(getApplicationProcessLink("booking"));
    }
  };

  return (
    <TransferWithoutProperty
      partnerName={partner?.name}
      onGoToBooking={handleGoToBooking}
      onGoToApplication={handleGoToApplication}
      isApplicationLoading={isCreateLeadLoading}
      isApplicationError={isCreateLeadError}
      isBookingLoading={isCreateLeadForBookingLoading}
      isBookingError={isCreateLeadForBookingError}
    />
  );
};

export default PartnerWithoutProperty;
